import { Link } from 'react-router-dom';
import styled, { DefaultTheme, css } from 'styled-components/macro';

import Button from 'components/Button/Button';
import ButtonIcon from 'components/ButtonIcon/ButtonIcon';
import FlexContainer from 'components/FlexContainer/FlexContainer';

type UserInfoPropsT = {
  iconOnly?: boolean;
};

const baseNavControl = css`
  justify-content: flex-start;
  width: 100%;
  height: auto;
  padding: 1rem 0.875rem;
  font-size: ${({ theme }) => theme.fontSize['2xl']};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
`;

export const FlexContainerStyled = styled(FlexContainer)<UserInfoPropsT>`
  padding: ${({ iconOnly }) => (!iconOnly ? '0 1.5rem' : '')};
`;

export const ButtonIconStyled = styled(ButtonIcon)`
  background: ${({ theme }) => theme.colors.transparent};
  @media (hover: hover) {
    &:hover {
      svg path {
        fill: ${({ theme }) => theme.colors.highlight.variant1};
      }
    }
  }
`;

export const getPopupContentStyle = (theme: DefaultTheme, isMobile: boolean) => ({
  minWidth: isMobile ? '180px' : '145px',
  borderRadius: theme.radius.sm,
});

export const ButtonStyled = styled(Button)`
  ${baseNavControl}

  ${({ theme }) => `
  ${theme.devices.tablet} {
    padding: 0.875rem;
    font-size: ${theme.fontSize.md};
  }
`}
`;

export const LinkStyled = styled(Link)`
  ${baseNavControl}

  display: inline-flex;
  color: ${({ theme }) => theme.colors.primary.variant1};

  ${({ theme }) => `
  ${theme.devices.tablet} {
    padding: 0.875rem;
    font-size: ${theme.fontSize.md};
  }
`}
`;

export const DropdownItemStyled = styled.li`
  &:hover {
    background-color: ${({ theme }) => theme.colors.white};
  }

  &:first-child {
    border-radius: ${({ theme }) => `${theme.radius.sm} ${theme.radius.sm} 0 0`};
  }

  &:last-child {
    border-radius: 0 0 ${({ theme }) => `${theme.radius.sm} ${theme.radius.sm}`};
  }
`;
